import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useGroupData } from '../../hooks/useGroups';
import StatCard from '../../components/ui/StatCard';
import { fmt, fmtDate } from '../../lib/constants';

export default function GroupHome() {
  const { profile, member } = useAuth();
  const navigate = useNavigate();
  const { group, members, events, finances, todos, loading } = useGroupData(profile?.group_id);

  if (loading) return <div style={{textAlign:'center',padding:40,color:'var(--text3)'}}>Loading…</div>;

  const income   = finances.filter(f=>f.type==='income').reduce((s,f)=>s+Number(f.amount),0);
  const expense  = finances.filter(f=>f.type==='expense').reduce((s,f)=>s+Number(f.amount),0);
  const upcoming = events.filter(e=>new Date(e.date)>=new Date()).sort((a,b)=>new Date(a.date)-new Date(b.date));
  const pending  = todos.filter(t=>t.status!=='done');

  return (
    <div>
      <div className="welcome-banner" style={{backgroundImage:'linear-gradient(135deg,#002277,#003399)'}}>
        <div style={{fontSize:13,opacity:.7,marginBottom:4}}>Group Dashboard —</div>
        <div className="welcome-name">{group?.name || 'Group'}</div>
        <div className="welcome-sub">Managed by {member?.first_name} {member?.last_name}</div>
      </div>

      <div className="grid-4 mb-4">
        <StatCard icon="👥" label="Members"        value={members.length}         color="blue" />
        <StatCard icon="📅" label="Upcoming Events" value={upcoming.length}        color="red" />
        <StatCard icon="💰" label="Balance"         value={fmt(income-expense)}    color="green" sub={`Income: ${fmt(income)}`} />
        <StatCard icon="✅" label="Pending Tasks"   value={pending.length}         color="amber" />
      </div>

      <div className="grid-2">
        <div className="card">
          <div className="card-header"><h3>📅 Upcoming Events</h3><button className="btn btn-outline btn-sm" onClick={()=>navigate('/group/events')}>All →</button></div>
          {upcoming.slice(0,4).map(e=>(
            <div key={e.id} style={{padding:'10px 16px',borderBottom:'1px solid var(--border)'}}>
              <div style={{fontWeight:700,fontSize:13}}>{e.title}</div>
              <div style={{fontSize:11,color:'var(--text3)'}}>{fmtDate(e.date)}{e.time?` · ${e.time}`:''}{e.location?` · 📍${e.location}`:''}</div>
            </div>
          ))}
          {!upcoming.length && <div style={{padding:16,color:'var(--text3)',fontSize:13}}>No upcoming events</div>}
        </div>

        <div className="card">
          <div className="card-header"><h3>✅ Pending Tasks</h3><button className="btn btn-outline btn-sm" onClick={()=>navigate('/group/todos')}>All →</button></div>
          {pending.slice(0,5).map(t=>(
            <div key={t.id} style={{padding:'10px 16px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:10}}>
              <div style={{width:8,height:8,borderRadius:'50%',background:t.status==='in_progress'?'var(--blue)':'var(--text3)',flexShrink:0}} />
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:600}}>{t.title}</div>
                {t.due_date && <div style={{fontSize:11,color:'var(--text3)'}}>Due: {fmtDate(t.due_date)}</div>}
              </div>
              <span className={`badge badge-${t.status==='in_progress'?'blue':'gray'}`}>{t.status.replace('_',' ')}</span>
            </div>
          ))}
          {!pending.length && <div style={{padding:16,color:'var(--text3)',fontSize:13}}>🎉 All tasks complete!</div>}
        </div>
      </div>
    </div>
  );
}
